import { render, staticRenderFns } from "./FooterTnc.vue?vue&type=template&id=508522ba&scoped=true&"
import script from "./FooterTnc.vue?vue&type=script&lang=js&"
export * from "./FooterTnc.vue?vue&type=script&lang=js&"
import style0 from "./FooterTnc.vue?vue&type=style&index=0&id=508522ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508522ba",
  null
  
)

export default component.exports